import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// --- Oculta el warning de ResizeObserver en todas las etapas ---
// Este error es benigno y ocurre frecuentemente con React Flow y MUI
if (typeof window !== "undefined") {
  const resizeObserverErr = /ResizeObserver loop/;

  // Silencia el mensaje en la consola
  const realConsoleError = window.console.error;
  window.console.error = (...args) => {
    if (args[0] && typeof args[0] === "string" && resizeObserverErr.test(args[0])) {
      return;
    }
    realConsoleError(...args);
  };

  // Silencia el evento global de error (captura antes que React overlay)
  window.addEventListener("error", (e) => {
    if (e.message && resizeObserverErr.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    }
  }, true); // useCapture = true para capturar antes que otros handlers

  // Silencia el evento de promesas no manejadas
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason?.message && resizeObserverErr.test(e.reason.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  // Parche adicional para el ResizeObserver nativo
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        // Envuelve el callback en requestAnimationFrame para evitar el error
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            if (!resizeObserverErr.test(e.message)) {
              throw e;
            }
          }
        });
      });
    }
  };
}

// --- Render principal ---
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// --- Métricas opcionales ---
reportWebVitals();

// --- Service Worker: PWA + offline para muelle ---
// Cache del shell + stale-while-revalidate para /muelle/dia. Se registra solo
// en producción; en dev (CRA con HMR) un SW interferiría con el reload.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
      .then(reg => {
        // Si llega una nueva versión, le pedimos skipWaiting para activarla
        // sin requerir cerrar+abrir todas las pestañas.
        reg.addEventListener('updatefound', () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener('statechange', () => {
            if (sw.state === 'installed' && navigator.serviceWorker.controller) {
              sw.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => { /* silent — sin SW la app sigue funcionando online */ });
  });

  // Cuando un nuevo SW toma control, recargamos para usar el shell actualizado.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

